export const elevatedAccess = [101, 465, 520, 530, 538, 429];